import type { DocumentFlowDoc, FlowBlock, FlowInline } from './schema';

const namesInInline = (content: FlowInline[] | undefined, into: Set<string>): void => {
	for (const node of content ?? []) {
		if (node.type === 'field') {
			into.add(node.attrs.name);
		}
	}
};

const namesInBlocks = (blocks: FlowBlock[], into: Set<string>): void => {
	for (const block of blocks) {
		if (block.type === 'paragraph') {
			namesInInline(block.content, into);
			continue;
		}
		if (block.type === 'bulletList' || block.type === 'orderedList') {
			for (const item of block.content) {
				namesInBlocks(item.content, into);
			}
			continue;
		}
		if (block.type === 'table') {
			for (const row of block.content) {
				for (const cell of row.content) {
					namesInBlocks(cell.content, into);
				}
			}
		}
	}
};

/**
 * Every field name the document actually uses, wherever it is nested.
 *
 * Read from the node tree, so a field cannot be missed by a regex or invented by one. Used to
 * hold `fieldBindings` down to the fields that exist: a stored link nothing uses reads as
 * progress towards "everything is linked" when it is not.
 */
export const flowFieldNames = (doc: DocumentFlowDoc): Set<string> => {
	const names = new Set<string>();
	namesInBlocks(doc.content, names);
	return names;
};
